import styled from 'styled-components';

const Label = styled.div<{ $fontSize?: string; $fontWeight?: string; $color?: string }>`
    font-size: ${props => props.$fontSize};
    font-weight: ${props => props.$fontWeight};
    color: ${props => props.$color};
    vertical-align: middle;
`;

export default Label;
